'use client'
import { motion } from 'framer-motion'
import React from 'react'

export interface ViewToggleProps {
    currentView: 'box' | 'horizontal';
    onViewChange: (view: 'box' | 'horizontal') => void;
    className?: string;
}

export default function ViewToggle({ currentView, onViewChange, className = '' }: ViewToggleProps) {
    return (
        <div className={`flex items-center gap-2 ${className}`}>
            {/* Box/Grid View Button */}
            <motion.button
                type="button"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => onViewChange('box')}
                className={`p-2 rounded-lg transition-colors duration-200 ${
                    currentView === 'box' 
                        ? 'bg-red-600 text-white' 
                        : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
                }`}
                aria-label="Grid view"
            >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M3 3h7v7H3V3zm11 0h7v7h-7V3zm-11 11h7v7H3v-7zm11 0h7v7h-7v-7z"/>
                </svg>
            </motion.button>

            {/* List/Horizontal View Button */}
            <motion.button
                type="button"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => onViewChange('horizontal')}
                className={`p-2 rounded-lg transition-colors duration-200 ${
                    currentView === 'horizontal' 
                        ? 'bg-red-600 text-white' 
                        : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
                }`}
                aria-label="List view"
            >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"/>
                </svg>
            </motion.button>
        </div>
    )
}
